/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { get, find } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestPlansIfNotRequested } from 'state/visual-deck-plans/actions';
import { getAllVisualDeckPlans, requestingVisualDeckPlans } from 'state/visual-deck-plans/selectors';
import { swapSubscription } from 'state/subscriptions/actions';
import { getCurrentVisualDeckId, getCurrentVisualDeckPlanId, getCurrentVisualDeck } from 'state/current-visual-deck/selectors';
import { successNotice } from 'state/notices/actions';
import { requestAddonsIfNotRequested } from 'state/addons/actions';
import Loader from './loader';
import { getAllAddons } from 'state/addons/selectors';
import Plan from './plan';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';
import cb from 'lib/chargebee';
import Money from 'components/money';
import ConfirmNewPlanAlert from './confirm-new-plan-alert'; // Import
import { requestCurrentVisualDeck } from 'state/current-visual-deck/actions';
import { getCurrentUser } from 'state/current-user/selectors';
import { requestCouponsIfNotRequested } from 'state/coupons/actions';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import FlashMessage from 'components/flash-message';
import page from 'page';

/**
 * Style dependencies
 */
import './styles.scss';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const SelectVisualDeckPlan = (props) => {
    const visualDeckPlans = props.visualDeckPlans;
    const [submitting, setSubmitting] = useState(false);
    const [values, setValues] = useState({});

    const onChange = (value) => {
        //if (!props.visualDeckSubscriptionId) {
            return newPlanSubscription(value);
        //}

        let plan = find(visualDeckPlans, { id: value });
        let addon = resolveLicenseAddon(plan);

        confirmAlert({
            title: 'Subscribe to Visual Deck',
            message: 'Select a Visual Deck plan.',
            submitting,
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ConfirmNewPlanAlert
                    currentVisualDeck={props.currentVisualDeck}
                    newPlanId={plan.id}
                    plan={plan}
                    addon={addon}
                    onClose={onClose}
                    onSubmit={() => handleSubscribe(value)}
                />
            ),
        });
    };

    useEffect(() => {
        props.requestVisualDeckPlans();
        props.requestAddons();
        props.requestCoupons();
    }, []);

    const handleSubscribe = (value) => {
        setSubmitting(true);

        return props
            .swapSubscription(props.visualDeckSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Visual Deck subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const handleSubmit = (value) => {
        setSubmitting(true);
        return props
            .swapSubscription(props.visualDeckSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Visual Deck subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const newPlanSubscription = (planId) => {
        cb.openCheckout({
            hostedPage: () => cscom.hostedPage().newPlanSubscription(planId),
            error: (e) => console.log(e),
            //close: () => { window.location.reload(); },
            success: () => {
                props.requestCurrentVisualDeck();
                props.successNotice('Your Visual Deck subscription has been created.');
                page.redirect('/dashboard/visual-deck');
            },
        });
    };

    const resolveLicenseAddon = (plan) => {
        return null;
    };

    if (props.requesting) {
        return <Loader />;
    }

    return (
        <form onSubmit={handleSubmit}>
            <Box>
                <Stack space='xxlarge'>
                    {visualDeckPlans.map((plan, i) => {
                        return (
                                <Plan
                                key={plan.id}
                                plan={plan}
                                onClick={() => onChange(plan.id)}
                                disabled={
                                    !(props.currentVisualDeck && props.currentVisualDeck.status == 'cancelled')
                                        ? plan.id == props.visualDeckPlanId
                                        : null
                                }
                                licenseAddon={resolveLicenseAddon(plan)}
                                numberLicenses={props.currentUser.additionalLicenses}
                            />
                        );
                    })}
                </Stack>
            </Box>
        </form>
    );
};

export default connect(
    (state) => ({
        visualDeckPlans: getAllVisualDeckPlans(state),
        addons: getAllAddons(state),
        visualDeckSubscriptionId: getCurrentVisualDeckId(state),
        visualDeckPlanId: getCurrentVisualDeckPlanId(state),
        currentVisualDeck: getCurrentVisualDeck(state),
        currentUser: getCurrentUser(state),
        requesting: requestingVisualDeckPlans(state),
    }),
    {
        requestVisualDeckPlans: requestPlansIfNotRequested,
        requestCurrentVisualDeck,
        requestCoupons: requestCouponsIfNotRequested,
        swapSubscription,
        successNotice,
        requestAddons: requestAddonsIfNotRequested,
    },
)(SelectVisualDeckPlan);
